import { CanActivateFn, Router } from '@angular/router';
import { AccountService } from '../_services/account/account.service';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { map, take } from "rxjs";

const checkRegistration = (user: any, router: Router, toastr: ToastrService): boolean => {
  const role = user.role?.toLowerCase();
  if (role === 'admin' || role === 'administrator' || role === 'super-admin') {
    return true;
  }

  // If registration is explicitly false or undefined (not completed)
  if (!user.registrationCompleted) {
    const step = user.registrationStep || 1;
    let redirectUrl = '/auth/email-verification';
    
    if (step === 1) redirectUrl = '/auth/email-verification';
    else if (step === 2) redirectUrl = '/auth/phone-verification';
    else if (step === 3) redirectUrl = '/auth/user-details';

    toastr.warning("Please complete your registration first!");
    router.navigate([redirectUrl]);
    return false;
  }
  return true;
};

export const superAdminGuard: CanActivateFn = (_route, _state) => {
  const accountService: AccountService = inject(AccountService);
  const toastr: ToastrService = inject(ToastrService);
  const router: Router = inject(Router);

  return accountService.currentUser$.pipe(
    take(1),
    map((user: any) => {
      if (!user) {
        toastr.error("Please login to access this area!");
        router.navigate(['/auth/login']);
        return false;
      }

      const userRole = user.role?.toLowerCase();
      if (userRole === 'super-admin') {
        return checkRegistration(user, router, toastr);
      } else {
        toastr.error("Access denied! Super Admin privileges required.");
        router.navigate(['/']);
        return false;
      }
    })
  )
};

export const adminGuard: CanActivateFn = (_route, _state) => {
  const accountService: AccountService = inject(AccountService);
  const toastr: ToastrService = inject(ToastrService);
  const router: Router = inject(Router);

  return accountService.currentUser$.pipe(
    take(1),
    map((user: any) => {
      if (!user) {
        toastr.error("Please login to access this area!");
        router.navigate(['/auth/login']);
        return false;
      }

      const userRole = user.role?.toLowerCase();
      if (userRole === 'admin' || userRole === 'super-admin') {
        return checkRegistration(user, router, toastr);
      } else {
        toastr.error("Access denied! Admin privileges required.");
        router.navigate(['/']);
        return false;
      }
    })
  )
};

export const userGuard: CanActivateFn = (_route, _state) => {
  const accountService: AccountService = inject(AccountService);
  const toastr: ToastrService = inject(ToastrService);
  const router: Router = inject(Router);

  return accountService.currentUser$.pipe(
    take(1),
    map((user: any) => {
      if (!user) {
        toastr.error("Please login to access this area!");
        router.navigate(['/auth/login']);
        return false;
      }

      const userRole = user.role?.toLowerCase();
      if (userRole === 'user') {
        return checkRegistration(user, router, toastr);
      } else {
        toastr.error("Access denied! User privileges required.");
        router.navigate(['/']);
        return false;
      }
    })
  )
};
